module.exports = __webpack_public_path__ + "img/VectorDown.6c7123f4.svg";